<div class="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
  <!-- 5. Carte d'accès direct à la fiche publique -->
  @if (publicProfileUrl(); as url) {
    <div
      class="sm:col-span-2 p-4.5 rounded-2xl bg-gradient-to-r from-primary-1 via-white dark:from-primary-2/30 dark:via-neutral-2 dark:to-primary-3/30 border border-primary-4 dark:border-primary-5 shadow-xs flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
    >
      <div class="flex items-center gap-3.5 min-w-0">
        <div
          class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0"
        >
          <mat-icon class="!text-primary-9 !w-5 !h-5 !text-xl">storefront</mat-icon>
        </div>
        <div class="min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="text-sm font-bold text-neutral-12">Votre fiche agent en ligne</span>
            @if (resolved().isPublic) {
              <span
                class="inline-flex items-center gap-1.5 text-[10px] font-extrabold px-2 py-0.5 rounded-full bg-jade-2 text-jade-11 border border-jade-5"
              >
                <span class="w-1.5 h-1.5 rounded-full bg-jade-9"></span>
                Visible publiquement
              </span>
            } @else {
              <span
                class="inline-flex items-center gap-1.5 text-[10px] font-extrabold px-2 py-0.5 rounded-full bg-neutral-2 text-neutral-10 border border-neutral-3"
              >
                <span class="w-1.5 h-1.5 rounded-full bg-neutral-8"></span>
                Masquée
              </span>
            }
          </div>
          <p class="text-xs text-neutral-11 mt-0.5 leading-relaxed">
            @if (resolved().isPublic) {
              Consultez votre fiche agent telle qu'elle apparaît pour les propriétaires vendeurs et vos
              clients.
            } @else {
              Votre fiche est actuellement masquée du public. Vous pouvez la prévisualiser via ce lien privé.
            }
          </p>
        </div>
      </div>

      <div class="flex items-center gap-2.5 shrink-0 self-stretch sm:self-auto flex-wrap">
        <a
          routerLink="/user/agent/profile"
          class="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-xs font-bold text-neutral-12 bg-white dark:bg-neutral-2 hover:bg-neutral-2 dark:hover:bg-neutral-3 border border-neutral-4 dark:border-neutral-5 transition-all shadow-xs shrink-0 cursor-pointer flex-1 sm:flex-initial"
          matTooltip="Prévisualiser ma fiche directement dans l'application agent"
        >
          <mat-icon class="!text-neutral-10 !w-4 !h-4 !text-base">preview</mat-icon>
          <span>Aperçu interne</span>
        </a>

        <a
          [href]="url"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-xs font-bold text-white bg-primary-9 hover:bg-primary-10 transition-all shadow-xs shrink-0 cursor-pointer flex-1 sm:flex-initial"
          matTooltip="Ouvrir la fiche sur la plateforme publique dans un nouvel onglet"
        >
          <mat-icon class="!text-white !w-4 !h-4 !text-base">open_in_new</mat-icon>
          <span>Fiche publique</span>
        </a>
      </div>
    </div>
  }

  <!-- 1. Statut public -->
  <div
    class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs flex items-center justify-between gap-3"
  >
    <div class="flex items-center gap-3 min-w-0">
      <div
        class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
        [class.bg-primary-2]="resolved().isPublic"
        [class.text-primary-11]="resolved().isPublic"
        [class.bg-neutral-2]="!resolved().isPublic"
        [class.dark:bg-neutral-3]="!resolved().isPublic"
        [class.text-neutral-10]="!resolved().isPublic"
      >
        <mat-icon class="!w-4.5 !h-4.5 !text-lg">{{
          resolved().isPublic ? 'visibility' : 'visibility_off'
        }}</mat-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-xs text-neutral-10 font-medium">Statut de diffusion</span>
        <span class="text-sm font-bold text-neutral-12">
          {{ resolved().isPublic ? 'Visible publiquement' : 'Profil masqué' }}
        </span>
      </div>
    </div>
    <div class="flex items-center gap-2 shrink-0">
      <span
        class="text-[10px] font-bold px-2 py-0.5 rounded-full border shrink-0"
        [class.bg-primary-2]="resolved().isPublic"
        [class.text-primary-11]="resolved().isPublic"
        [class.border-primary-4]="resolved().isPublic"
        [class.bg-neutral-2]="!resolved().isPublic"
        [class.dark:bg-neutral-3]="!resolved().isPublic"
        [class.text-neutral-10]="!resolved().isPublic"
        [class.border-neutral-3]="!resolved().isPublic"
        [class.dark:border-neutral-4]="!resolved().isPublic"
      >
        {{ resolved().isPublic ? 'Actif' : 'Masqué' }}
      </span>
    </div>
  </div>

  <!-- 2. Disponibilité / Vacances -->
  <div
    class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs flex items-center justify-between gap-3"
  >
    <div class="flex items-center gap-3 min-w-0">
      <div
        class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
        [class.bg-amber-2]="resolved().isVacationMode"
        [class.text-amber-11]="resolved().isVacationMode"
        [class.bg-primary-2]="!resolved().isVacationMode"
        [class.text-primary-11]="!resolved().isVacationMode"
      >
        <mat-icon class="!w-4.5 !h-4.5 !text-lg">{{
          resolved().isVacationMode ? 'beach_access' : 'check_circle'
        }}</mat-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-xs text-neutral-10 font-medium">Disponibilité mandats</span>
        <span class="text-sm font-bold text-neutral-12">
          {{ resolved().isVacationMode ? 'En vacances (Pause)' : 'Disponible pour mandats' }}
        </span>
      </div>
    </div>
    <span
      class="text-[10px] font-bold px-2 py-0.5 rounded-full border shrink-0"
      [class.bg-amber-2]="resolved().isVacationMode"
      [class.text-amber-11]="resolved().isVacationMode"
      [class.border-amber-4]="resolved().isVacationMode"
      [class.bg-primary-2]="!resolved().isVacationMode"
      [class.text-primary-11]="!resolved().isVacationMode"
      [class.border-primary-4]="!resolved().isVacationMode"
    >
      {{ resolved().isVacationMode ? 'En pause' : 'Disponible' }}
    </span>
  </div>

  <!-- 3. Référencement SEO -->
  <div
    class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs flex items-center justify-between gap-3"
  >
    <div class="flex items-center gap-3 min-w-0">
      <div
        class="w-9 h-9 rounded-xl bg-neutral-2 dark:bg-neutral-3 text-neutral-11 flex items-center justify-center shrink-0"
      >
        <mat-icon class="!w-4.5 !h-4.5 !text-lg">travel_explore</mat-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-xs text-neutral-10 font-medium">Moteurs de recherche</span>
        <span class="text-sm font-bold text-neutral-12">
          {{ resolved().allowSearchIndexing ? 'Indexé sur Google' : 'Indexation coupée' }}
        </span>
      </div>
    </div>
    <span
      class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-neutral-2 dark:bg-neutral-3 text-neutral-10 dark:text-neutral-11 border border-neutral-3 dark:border-neutral-4 shrink-0"
    >
      {{ resolved().allowSearchIndexing ? 'Indexé' : 'Désactivé' }}
    </span>
  </div>
</div>
